import React from "react";
import "../Contact.css";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { FaPhone, FaArrowRight, FaEnvelope, FaMapMarkerAlt, FaClock,  FaUser,
  FaPhoneAlt,
  FaBuilding,
  FaTag,
  FaLaptopCode,
  FaWallet,
  FaRegCommentDots,
  FaArrowDown,
  FaPaperPlane } from "react-icons/fa";


const Contact = () => {
  return (
    <>
      <Header />
        <title>VisionVote Technologies | Contact Us</title>
      <div className="contact-page">

        {/* ================= HERO ================= */}

        <section className="contact-hero">

          <div className="contact-overlay"></div>

          <div className="container contact-hero-grid">

            {/* Left */}

            <div className="contact-hero-content">

              <span className="hero-tag">
                CONTACT VISIONVOTE TECHNOLOGIES
              </span>

              <h1>
                Let's Build the
                <span> Future Together</span>
              </h1>

              <p>
                Have an idea, a business challenge, or a digital transformation
                goal? Our team is ready to help you turn your vision into
                innovative software solutions. Reach out today and let's create
                something exceptional together.
              </p>

              <div className="hero-buttons">

                <button className="primary-btn">
                  Get In Touch
                  <FaArrowDown />
                </button>

                <button className="secondary-btn">
                  Schedule Consultation
                  <FaArrowDown />
                </button>

              </div>

            </div>

            {/* Right */}

            <div className="contact-hero-image">

              <svg
                viewBox="0 0 650 500"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="contactGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >

                    <stop offset="0%" stopColor="#2563eb" />

                    <stop offset="100%" stopColor="#60a5fa" />

                  </linearGradient>

                </defs>

                <circle
                  cx="540"
                  cy="90"
                  r="55"
                  fill="#DBEAFE"
                />

                <circle
                  cx="120"
                  cy="420"
                  r="70"
                  fill="#E0F2FE"
                />

                {/* Laptop */}

                <rect
                  x="140"
                  y="90"
                  width="360"
                  height="240"
                  rx="20"
                  fill="url(#contactGradient)"
                />

                <rect
                  x="165"
                  y="115"
                  width="310"
                  height="190"
                  rx="14"
                  fill="#fff"
                />

                {/* Chat Bubble */}

                <rect
                  x="210"
                  y="150"
                  width="210"
                  height="80"
                  rx="14"
                  fill="#EFF6FF"
                />

                <rect
                  x="235"
                  y="170"
                  width="150"
                  height="8"
                  rx="4"
                  fill="#2563eb"
                />

                <rect
                  x="235"
                  y="190"
                  width="120"
                  height="8"
                  rx="4"
                  fill="#93C5FD"
                />

                <rect
                  x="235"
                  y="210"
                  width="90"
                  height="8"
                  rx="4"
                  fill="#BFDBFE"
                />

                {/* Envelope */}

                <rect
                  x="250"
                  y="245"
                  width="140"
                  height="45"
                  rx="8"
                  fill="#2563eb"
                />

                <polyline
                  points="250,245 320,285 390,245"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="4"
                />

                {/* Stand */}

                <rect
                  x="305"
                  y="330"
                  width="40"
                  height="35"
                  rx="8"
                  fill="#94A3B8"
                />

                <rect
                  x="235"
                  y="365"
                  width="180"
                  height="16"
                  rx="8"
                  fill="#64748B"
                />

              </svg>

            </div>

          </div>

        </section>

        {/* ================= CONTACT INFO ================= */}

        <section className="contact-info">

          <div className="container">

            <div className="section-heading">

              <span className="section-tag">
                CONTACT INFORMATION
              </span>

              <h2>
                Multiple Ways to
                <span> Reach Our Team</span>
              </h2>

              <p>
                Whether you have a project idea, need technology consulting, or want
                to discuss your digital transformation journey, our team is here to
                help. Connect with us through any of the channels below.
              </p>

            </div>

            <div className="contact-info-grid">

              {/* Email */}

              <div className="contact-card">

                <div className="contact-icon">
                  📧
                </div>

                <h3>Email Us</h3>

                <p>
                  Reach out for project inquiries, partnerships, or general questions.
                </p>

                <a href="mailto:research@techvisionvote.in">
                  research@techvisionvote.in
                </a>

              </div>

              {/* Phone */}

              <div className="contact-card">

                <div className="contact-icon">
                  📞
                </div>

                <h3>Call Us</h3>

                <p>
                  Speak directly with our experts during business hours.
                </p>

                <a href="tel:03816780017">
                  03816780017
                </a>

              </div>

              {/* Office */}

              <div className="contact-card">

                <div className="contact-icon">
                  📍
                </div>

                <h3>Registered Office</h3>

                <p>
                  VisionVote Technologies Private Limited
                </p>

                <span>
                  H No-39a, Ramnagar Road, West Tripura, Ramnagar (west Tripura)
                  <br />
                  Sadar, Tripura, 799002
                  <br />
                  India
                </span>

              </div>

              {/* Hours */}

              <div className="contact-card">

                <div className="contact-icon">
                  🕒
                </div>

                <h3>Business Hours</h3>

                <p>

                  Monday – Friday
                  <br />

                  <strong>09:00 AM – 06:30 PM</strong>

                </p>

                <span>
                  Saturday & Sunday
                  <br />
                  Closed
                </span>

              </div>

            </div>

          </div>



        </section>

        {/* ================= GET IN TOUCH ================= */}

        <section className="get-in-touch">

          <div className="container get-touch-grid">

            {/* LEFT : CONTACT FORM */}

            <div className="contact-form-wrapper">

              <span className="section-tag">
                GET IN TOUCH
              </span>

              <h2>
                Let's Start Your
                <span> Next Project</span>
              </h2>

              <p>
                Whether you're looking for custom software development, AI-powered
                solutions, cloud consulting, or digital transformation services,
                we'd love to hear from you. Fill out the form below and our team
                will get back to you shortly.
              </p>

              <form className="contact-form">

                <div className="form-row">

                  <div className="input-box">
                    <FaUser className="input-icon" />
                    <input
                      type="text"
                      placeholder="Full Name *"
                    />
                  </div>

                  <div className="input-box">
                    <FaEnvelope className="input-icon" />
                    <input
                      type="email"
                      placeholder="Email Address *"
                    />
                  </div>

                </div>

                <div className="form-row">

                  <div className="input-box">
                    <FaPhoneAlt className="input-icon" />
                    <input
                      type="tel"
                      placeholder="Phone Number"
                    />
                  </div>

                  <div className="input-box">
                    <FaBuilding className="input-icon" />
                    <input
                      type="text"
                      placeholder="Company Name"
                    />
                  </div>

                </div>

                <div className="input-box" style={{ marginBottom: '22px' }}>
                  <FaTag className="input-icon" />
                  <input
                    type="text"
                    placeholder="Project Subject"
                  />
                </div>

                <div className="input-box" style={{ marginBottom: '22px' }}>
                  <FaLaptopCode className="input-icon" />

                  <select>
                    <option>Select Service</option>
                    <option>Custom Software Development</option>
                    <option>Web Development</option>
                    <option>Mobile App Development</option>
                    <option>AI & Automation</option>
                    <option>Cloud Solutions</option>
                    <option>Technology Consulting</option>
                    <option>UI / UX Design</option>
                    <option>Support & Maintenance</option>
                    <option>General Enquiries</option>
                    <option>Others</option>
                  </select>

                </div>

                <div className="input-box" style={{ marginBottom: '22px' }}>
                  <FaWallet className="input-icon" />

                  <select>
                    <option>Select Budget</option>
                    <option>Below ₹50,000</option>
                    <option>₹50,000 - ₹2 Lakhs</option>
                    <option>₹2 Lakhs - ₹10 Lakhs</option>
                    <option>Above ₹10 Lakhs</option>
                    <option>Not Sure</option>
                  </select>

                </div>

                <div className="input-box textarea-box">
                  <FaRegCommentDots className="input-icon textarea-icon" />

                  <textarea
                    rows="6"
                    placeholder="Tell us about your project..."
                  ></textarea>

                </div>

                <div className="checkbox-group">

                  <input
                    type="checkbox"
                    id="privacy"
                  />

                  <label htmlFor="privacy">
                    I agree to the Privacy Policy and consent to being contacted regarding my inquiry.
                  </label>

                </div>

                <button
                  type="submit"
                  className="submit-btn"
                >
                  <FaPaperPlane />
                  Send Message
                </button>

              </form>

            </div>

          </div>

        </section>




      </div>

      <Footer />
    </>
  );
};

export default Contact;